import {
  INICIALITZAR,
  OBTENIR_DADES_CREACIO_INDIVIDU,
  VISUALITZACIO_OBTENIR_DADES
} from "../../actions/actionTypes";

const ESTAT_INICIAL = {};

const llistat = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case `${OBTENIR_DADES_CREACIO_INDIVIDU}_EN_CURS`:
      return {
        ...state
      };

    case `${OBTENIR_DADES_CREACIO_INDIVIDU}_SUCCESS`:
    case `${VISUALITZACIO_OBTENIR_DADES}_SUCCESS`:
      return action.payload.classes;

    case `${OBTENIR_DADES_CREACIO_INDIVIDU}_ERROR`:
      return {
        ...state,
        error: action.error
      };

    default:
      return state;
  }
};

export default llistat;

const llistatTotesClasses = state => state.llistat;

export const getLlistatClasses = state => {
  const llistatClasses = llistatTotesClasses(state);
  if (!llistatClasses) {
    return null;
  }
  return llistatClasses;
};

export const getClasses = state => state.llistat;

export const getClassesAsArray = state => {
  const classesIndexatsPerId = getClasses(state);
  return Object.keys(classesIndexatsPerId).map(idClasse => ({
    ...classesIndexatsPerId[idClasse],
    id: parseInt(idClasse)
  }));
};
